export default {
    dCrops(item) {
        const nft = JSON.parse(item.grouping.nft);
        item.edition = nft.edition;
        item.rarity = nft.rarity;
    }
}